// export const IMG_URL = "http://192.168.16.56:1122";
// export const IMG_URL = "https://mywealth-node.profcymabackend.com:1919";

// export const IMG_URL = "https://mywealthwave.hostelbliss.com:4343";

export const IMG_URL = (image) => {
  if (!image) return "";

  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }

  return `${process.env.REACT_APP_IMAGE_URL}${image}`;
};

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};
